<template>
  <div class="also-read-wrapper">
    <div :class="`also-read-article-wrapper ${article.isLast ? 'last': ''}`">
      <span class="also-read-tag">also read</span>
      <div class="also-read-content">
        <a class="also-read-content-title" :href="node.relative_url">
          {{title}}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import { getSocialHeadLingAsTitle } from 'mixins/utilities'

  export default {
    name: 'also-read',
    computed: {
      node() {
        return get(this, 'article.node', {})
      },
      title() {
        return getSocialHeadLingAsTitle(this.node)
      },
    },
    props: {
      article: {
        type: Object,
        default: {},
      },
    },
  }
</script>
<style lang="scss" scoped>
  .also-read-wrapper {
    margin-top: rem-calc(14);
    margin-left: rem-calc(27);
    margin-right: rem-calc(27);
    @include respond-to('desktop') {
      margin-top: rem-calc(40);
    }
  }

  .also-read-article-wrapper,
  .also-read-wrapper {
    margin-bottom: rem-calc(14);
    @include respond-to('desktop') {
      margin-bottom: rem-calc(40);
    }
  }

  .also-read-tag {
    color: $white;
    position: relative;
    background-color: $amp-dark-turquoise;
    text-transform: uppercase;
    font-weight: bold;
    display: inline-block;
    font-size: rem-calc(14);
    line-height: rem-calc(26);
    padding: rem-calc(2 12 0 16);
    font-family: $barlow;

    &:before {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: rem-calc(12 0 0 12);

      border-color: transparent transparent transparent $white;
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

  .also-read-content {
    border-style: solid;
    border-color: $amp-dark-turquoise;
    border-width: rem-calc(4 0);

    &-title {
      display: inline-block;
      font-family: $barlow;
      font-size: rem-calc(20);
      font-weight: bold;
      line-height: rem-calc(26);
      color: $black;
      text-decoration: underline $amp-text-underline;
      padding-top: rem-calc(7);
      padding-bottom: rem-calc(13);
    }
  }
</style>



// WEBPACK FOOTER //
// AmpAlsoRead.vue?b028bd66